import * as yup from "yup";
import { validationArraySelect, validationNotEmpty, validationWithoutSpace, } from "./defaultValidations";

export default yup.object({
  addUser: validationArraySelect("Add User"),
});